import Actions from 'src/components/Actions';
import Search from 'src/components/Search';
import { variables } from 'src/Tenants';
import React from 'react';
import Checkbox from 'src/components/Checkbox';
import { setDisplayClosedAndResolvedTickets } from 'src/store/actions/serviceRequestsByGroup';
import Button from 'src/components/Button';
import FontAwesomeIcon from 'src/components/Icon';
import classNames from 'classnames';
import { setServiceRequestFormIsVisible } from 'src/store/actions/serviceRequestForm';

const CreateRequestButton = ({
  isCreateRequestDisabled,
  user,
  dispatch,
}: any) => {
  if (
    user.roles[0].role.name === 'Vendor' ||
    user.roles[0].role.name === 'Service Provider' ||
    user.roles[0].role.name === 'Realtor'
  ) {
    return null;
  }

  const isDisabled: boolean =
    isCreateRequestDisabled && user.roles?.[0]?.role?.name === 'Home Owner';

  return (
    <Button
      color="teal"
      label="Create Request"
      onClick={() => dispatch(setServiceRequestFormIsVisible(true))}
      icon={<FontAwesomeIcon glyph="wrench" weight="light" size="small" />}
      size="small"
      disabled={isDisabled}
    />
  );
};

const FilterButton = ({ onOpenFilters }) => {
  const pathName = window.location.pathname;

  if (pathName !== '/app/service-requests') return null;

  return (
    <Button
      color="teal"
      label="Filter By"
      size="small"
      onClick={onOpenFilters}
      icon={<FontAwesomeIcon glyph="filter" weight="light" size="small" />}
    />
  );
};

const DownloadButton = ({ serviceRequests, onOpenDownloadModal }) => {
  if (!serviceRequests || serviceRequests.length === 0) return null;

  return (
    <div onClick={onOpenDownloadModal} style={{ cursor: 'pointer' }}>
      <FontAwesomeIcon glyph="download" weight="regular" size="big" />
    </div>
  );
};

const BulkUpdateControls = ({
  user,
  allowedStatuses,
  selectedIds,
  isGroupSelected,
  status,
  onChangeStatus,
}) => {
  if (
    user.roles[0].role.name === 'Home Owner' ||
    user.roles[0].role.name === 'Realtor' ||
    user.roles[0].role.name === 'Vendor'
  ) {
    return null;
  }

  return (
    <div className="bulkUpdateServReq">
      <select
        className={classNames('select__bulkUpdate_options', {
          'select__bulkUpdate_options--background':
            selectedIds.length > 0 || isGroupSelected,
        })}
        disabled={!(selectedIds.length > 0 || isGroupSelected)}
        onChange={onChangeStatus}
        value={status || ''}
      >
        {/* @ts-expect-error */}
        <option disabled="disabled">BULK STATUS UPDATE</option>
        {allowedStatuses.map((stat: any, i: any) => (
          <option key={i} value={stat.label}>
            {stat.label}
          </option>
        ))}
      </select>
    </div>
  );
};

const SelectAllCheckbox = ({ selectAll, onSelectAll }) => (
  <div className="servReqSelectAll">
    <Checkbox label="Select All" value={selectAll} onChange={onSelectAll} />
  </div>
);

const GroupButton = ({ selectedIds, onGroupBy }) => {
  const pathName = window.location.pathname;

  if (pathName !== '/app/service-requests') return null;

  return (
    <div className="groupByBtn">
      <Button
        color="teal"
        label="Group"
        size="small"
        disabled={selectedIds.length === 0}
        onClick={onGroupBy}
      />
    </div>
  );
};

const ShowResolvedTicketsCheckbox = ({
  from,
  displayClosedAndResolvedTickets,
  dispatch,
  filterQuery,
  onFilterBySearch,
}) => {
  if (from !== 'dashboard') return null;

  return (
    <div className="servReqSelectAll">
      <Checkbox
        label="Show Resolved Tickets"
        value={displayClosedAndResolvedTickets}
        onChange={() => {
          dispatch(
            setDisplayClosedAndResolvedTickets(!displayClosedAndResolvedTickets)
          );
          onFilterBySearch(filterQuery);
        }}
      />
    </div>
  );
};

const SearchAndActionsBar = ({
  searchString,
  onSearch,
  user,
  allowedStatuses,
  selectedIds,
  isGroupSelected,
  status,
  onChangeStatus,
  onOpenFilters,
  onGroupBy,
  selectAll,
  onSelectAll,
  serviceRequests,
  onOpenDownloadModal,
  isCreateRequestDisabled,
  dispatch,
  from,
  displayClosedAndResolvedTickets,
  filterQuery,
  onFilterBySearch,
  itemView,
  mainServiceRequest,
}: any) => (
  <Actions compact>
    <div className="searchbar serviceRequestsSearch">
      <Search
        size="small"
        placeholder={`Search ${variables.serviceRequest}s...`}
        value={searchString}
        onChange={onSearch}
        theme={undefined}
      />
      <div className="serviceRequestsTable searchbar1">
        <FilterButton onOpenFilters={onOpenFilters} />
        <div
          className="CreateRequestButtonM"
          style={{ display: 'inline-block', float: 'right' }}
        >
          {/* Todo: Hotfix to hide create SR button for Contacts until root cause addressed here - https://app.asana.com/1/41213529744312/project/1208712340140532/task/1211655361372930?focus=true */}
          {['Property', 'Suite'].includes(from) &&
            !(itemView && itemView === true) &&
            !mainServiceRequest && (
              <CreateRequestButton
                isCreateRequestDisabled={isCreateRequestDisabled}
                user={user}
                dispatch={dispatch}
              />
            )}
        </div>
        <div className="serviceRequestsDown">
          <DownloadButton
            serviceRequests={serviceRequests}
            onOpenDownloadModal={onOpenDownloadModal}
          />
        </div>
        <BulkUpdateControls
          user={user}
          allowedStatuses={allowedStatuses}
          selectedIds={selectedIds}
          isGroupSelected={isGroupSelected}
          status={status}
          onChangeStatus={onChangeStatus}
        />
        <GroupButton selectedIds={selectedIds} onGroupBy={onGroupBy} />
        <SelectAllCheckbox selectAll={selectAll} onSelectAll={onSelectAll} />
        <ShowResolvedTicketsCheckbox
          from={from}
          displayClosedAndResolvedTickets={displayClosedAndResolvedTickets}
          dispatch={dispatch}
          filterQuery={filterQuery}
          onFilterBySearch={onFilterBySearch}
        />
      </div>
    </div>
  </Actions>
);

export default SearchAndActionsBar;
